import { createContext, useState, useContext, useMemo, useCallback } from 'react'
import { getBranchRegions } from "../Services/branchRegionService"
import { BranchRegionContextType, IBranchHierarchyEmployeeDto, IBranchHierarchyRegionDto } from "../@types/branchRegion"
import { useEffectAsync } from '../Hooks/useEffectAsync'

const BranchRegionContext = createContext<BranchRegionContextType | null>(null)

const useBranchRegionContext = () => {
    const context = useContext(BranchRegionContext)
    if (context === undefined) {
        throw new Error("useBranchRegionContext was used outside of its Provider");
    }
    return context
}

const BranchRegionContextProvider = ({ children }: any) => {
    const [branchRegions, setBranchRegions] = useState<IBranchHierarchyRegionDto[]>([])
    const [employees, setEmployees] = useState<IBranchHierarchyEmployeeDto[]>([])
    const [open, setOpen] = useState(false);
    const [selectedRegionId, setSelectedRegionId] = useState("");
    const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
    const [selectedTitle, setSelectedTitle] = useState("");
    const [branchRegionDto, setBranchRegionDto] = useState<IBranchHierarchyRegionDto>({
        branchRegionId: 0,
        manager: '',
        managerEmployeeId: 0,
        managerEmployeeGuid: '',
        title: '',
        isActive: false
    });

    const load = useCallback(async () => {
        try {
            const branchHierarchyRegionResponse = await getBranchRegions();
            if (branchHierarchyRegionResponse) {
                setBranchRegions(branchHierarchyRegionResponse.branchHierarchyRegions)
                setEmployees(branchHierarchyRegionResponse.branchHierarchyEmployee)
            }
        } catch (error) {
            console.error(error)
        }
    }, [])
    const providerValue = useMemo(() => ({
        branchRegions, setBranchRegions,
        employees, setEmployees,
        open, setOpen,
        selectedRegionId, setSelectedRegionId,
        selectedEmployeeId, setSelectedEmployeeId,
        selectedTitle, setSelectedTitle,
        branchRegionDto, setBranchRegionDto,
        load
    }), [branchRegions, employees, open, selectedRegionId, selectedEmployeeId, selectedTitle, branchRegionDto, load]);

    useEffectAsync(async () => {
        await load();
    }, [load])

    return (
        <BranchRegionContext.Provider value={ providerValue }>
            {children}
        </BranchRegionContext.Provider>
    )
}

export { BranchRegionContext, BranchRegionContextProvider, useBranchRegionContext };